<div class="modal-header">
  <h3 class="modal-title">{{ title }}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

<div class="modal-body gt-dashboard-ex-body" [hidden]="minimise" [ngClass]="currentTheme">
  <p class="info-text">
    All elements listed below are required by the IRS. If any element is missing a value,
    please go to the ConsolidatedReturnHeader through the add/edit screens to update those values.
  </p>

  @if (!loading && headerList.length > 0) {
<div class="table-scroll">
    <table class="main-table">
      <thead>
        <tr>
          <th class="sticky-col" style="text-align: center;">Element Name</th>
          <th class="sticky-col" style="text-align: center;">Element value</th>
        </tr>
      </thead>
      @for (v of headerList; track $index; let i = $index) {

        <tbody [ngClass]="{'custom-border': isNewGroup(i)}">
          @if (showChoiceSeparator(i)) {
<tr>
            <td colspan="2" style="text-align: center;">
              Either above OR below set of elements in this block should contain values.
            </td>
          </tr>
}
          <tr>
            <td>{{v.ELEMENT_NAME}}</td>
            <td>{{v.ELEMENT_VALUE}}</td>
          </tr>
        </tbody>
      
}
    </table>
  </div>
}

  @if (loading) {
<div class="loader">
    <i class="fa fa-spinner fa-spin fa-4x"></i>
  </div>
}
</div>

<div class="modal-footer" [hidden]="minimise">
  <button class="save-button" type="button" (click)="confirm()">Proceed</button>
  <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
</div>
